import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const ServicesHomeUsers = ({ services, setPrestation, _choiceService }) => {
    const [showList, setShowList] = useState() 

    return ( 
        <div className='mt-3'>
            <p className='h5'>Choix de la prestation</p>
            {services.filter(l => l.doc === 'docList').sort((a,b) => a.nameList > b.nameList ? 1 : -1).map(l => (
                <div 
                    key={l.id} 
                    className='row mt-3 py-3 shadow' 
                    onClick={() => setShowList(showList === l.id ? '' : l.id)}
                >
                    <div className='col'>
                        {l.nameList}
                    </div>
                    <div className='col text-end'>
                        <i className={showList === l.id ? "bi bi-chevron-compact-up" : "bi bi-chevron-compact-down"}></i>
                    </div>
                    {showList === l.id && 
                        services.filter(s => s.nameList === l.nameList && s.doc === 'docService').sort((a,b) => a.nameService > b.nameService ? 1 : -1).map(s => (
                            <div key={s.id}>
                                <div className='row border-top mt-3 pt-3'>
                                    <div className='col'>
                                        {s.nameService}
                                        <br/>
                                        <span className='text-muted'>{s.durationService}min</span> <span className='text-bold mx-2'>{s.priceService}€</span> 
                                    </div>
                                    <div className='col text-end align-self-center'>
                                        <button 
                                            type="button" 
                                            className="btn shadow btn-sm rounded-pill" 
                                            onClick={() => [
                                                setPrestation(true),
                                                _choiceService(s.id, s.nameService, s.priceService, s.durationService)
                                            ]}
                                        >Choisir</button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            ))}
        </div>
    )
}

export default ServicesHomeUsers